import { IonCol, IonGrid, IonRow } from "@ionic/react";
import { FormattedMessage } from "react-intl";

import CircleButton from "@components/buttons/CircleButton";
import styles from "@components/MobileHeader.module.css";
import Heading2 from "@components/typography/Heading2";

type Props = {
  handleBack?: () => void;
  routerLink?: string;
  titleKey: string;
};

const MobileHeader = ({ handleBack, routerLink, titleKey }: Props) => (
  <div className={`ion-hide-lg-up ${styles.mobileHeader}`}>
    <IonGrid className="ion-no-padding">
      <IonRow className="ion-align-items-center">
        <IonCol>
          <CircleButton
            ariaLabelKey="accessibility.ariaLabels.back"
            color="gray-500"
            fill="clear"
            icon="chevronLeft"
            onClick={handleBack}
            routerLink={routerLink}
            size="medium"
          />
        </IonCol>
        <IonCol size="auto">
          <div className="no-wrap">
            <Heading2 bold color="black">
              <FormattedMessage id={titleKey} />
            </Heading2>
          </div>
        </IonCol>
        <IonCol />
      </IonRow>
    </IonGrid>
  </div>
);

export default MobileHeader;
